var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-message",class:_vm.className},[_c('p',{staticClass:"el-message__content"},[_vm._v(_vm._s(_vm.message))]),_c('el-button',{staticClass:"ml-2 mb-0 mt-0",attrs:{"type":"text"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('common.close')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }